(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpe-feeding-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpe-feeding-guide')) {
    customElements.define('dpe-feeding-guide', class extends HTMLElement {
      static portion(weight, bands, count, maxWeight) {
        if (!Number.isFinite(weight) || weight <= 0 || weight > maxWeight) return {state: 'invalid'};
        if (!Number.isInteger(count) || count < 1 || !bands.length || bands.some(b => !Number.isFinite(b.min) || !Number.isFinite(b.max) || b.min < 0 || (b.max !== 0 && b.max < b.min) || !Number.isInteger(b.chews) || b.chews < 1)) return {state: 'ambiguous'};
        const matches = bands.filter(b => weight >= b.min && (b.max === 0 || weight <= b.max));
        if (matches.length !== 1) return {state: 'ambiguous'};
        const band = matches[0];
        return {state: 'match', chews: band.chews, days: Math.floor(count / band.chews), label: band.label};
      }
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.weight = this.querySelector('[data-weight]');
        this.slider = this.querySelector('[data-weight-slider]');
        this.error = this.querySelector('[data-weight-error]');
        this.bands = [...this.querySelectorAll('[data-band]')].map(row => ({min:Number(row.dataset.min),max:Number(row.dataset.max),chews:Number(row.dataset.chews),label:row.dataset.label}));
        this.querySelector('[data-feeding-control]').hidden = false;
        this.querySelector('.dpe-feeding__table').open = false;
        this.weight.addEventListener('input', () => {
          if (this.weight.validity.valid) this.slider.value = this.weight.value;
          this.querySelector('[data-example-note]').style.visibility = 'hidden';
          this.calculate(false);
        });
        this.weight.addEventListener('blur', () => this.calculate(true));
        this.weight.addEventListener('keydown', event => {
          if (event.key === 'Enter') {event.preventDefault();this.calculate(true);}
        });
        this.slider.addEventListener('input', () => {this.weight.value = this.slider.value;this.querySelector('[data-example-note]').style.visibility = 'hidden';this.calculate(true);});
        this.querySelectorAll('[data-weight-step]').forEach(button => button.addEventListener('click', () => {
          const current = Number.isFinite(this.weight.valueAsNumber) ? this.weight.valueAsNumber : Number(this.slider.value);
          this.weight.value = Math.min(Number(this.weight.max),Math.max(.1,Math.round((current + Number(button.dataset.weightStep))*10)/10));
          this.slider.value = this.weight.value;this.querySelector('[data-example-note]').style.visibility = 'hidden';this.calculate(true);
        }));
        this.calculate(false);
      }
      calculate(showError) {
        const result = this.constructor.portion(this.weight.valueAsNumber, this.bands, Number(this.dataset.count), Number(this.weight.max));
        const invalid = result.state === 'invalid' || !this.weight.validity.valid;
        this.error.hidden = !invalid || !showError;
        if (invalid && showError) this.weight.setAttribute('aria-invalid','true'); else this.weight.removeAttribute('aria-invalid');
        this.querySelector('[data-result-empty]').hidden = !invalid;
        this.querySelector('[data-result-match]').hidden = true;
        this.querySelector('[data-result-ambiguous]').hidden = true;
        this.slider.style.setProperty('--weight-progress',`${(Number(this.slider.value)-.1)/(Number(this.slider.max)-.1)*100}%`);
        if (invalid) return;
        if (result.state === 'ambiguous') {this.querySelector('[data-result-ambiguous]').hidden = false;return;}
        this.querySelector('[data-chews]').textContent = result.chews;
        const label = this.querySelector('[data-chews-label]');
        label.textContent = result.chews === 1 ? label.dataset.one : label.dataset.many;
        this.querySelector('[data-days]').textContent = result.days;
        this.querySelector('[data-band-label]').textContent = result.label;
        this.querySelector('[data-result-match]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpe-joint-explainer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpe-joint-explainer')) {
    customElements.define('dpe-joint-explainer', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const on = (target, name, handler) => target.addEventListener(name, handler, {signal:this.events.signal});
        this.tabs = [...this.querySelectorAll('[data-joint-tab]')];
        this.panels = [...this.querySelectorAll('[data-joint-panel]')];
        this.visuals = [...this.querySelectorAll('[data-joint-visual]')];
        this.captions = [...this.querySelectorAll('[data-joint-caption]')];
        this.video = this.querySelector('video');
        this.playbackSurface = this.video || this.querySelector('.dpe-joint__visuals');
        this.progress = this.querySelector('[data-joint-progress]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.inView = false;
        this.activeIndex = 0;
        if (!this.tabs.length) return;
        const list = this.querySelector('[data-joint-tabs]');
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        list.setAttribute('aria-orientation', 'vertical');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          on(tab, 'click', () => this.select(index));
          on(tab, 'keydown', event => {
            const offsets = {ArrowRight:1, ArrowLeft:-1, ArrowDown:1, ArrowUp:-1};
            let next;
            if (event.key in offsets) next = (index + offsets[event.key] + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault(); this.select(next); this.tabs[next].focus();
          });
        });
        if (this.video) {
          this.video.controls = false;
          this.video.muted = true;
          this.video.loop = false;
          on(this.video, 'loadedmetadata', () => this.seekChapter());
          on(this.video, 'timeupdate', () => this.updateTimeline());
          on(this.video, 'ended', () => { this.seekChapter(); this.syncPlayback(); });
          on(this.video, 'play', () => this.showPlayback(true));
          on(this.video, 'pause', () => this.showPlayback(false));
          on(this.video, 'error', () => {
            this.wantsPlayback = false;
            this.video.controls = true;
            this.playbackSurface.removeAttribute('role');
            this.playbackSurface.removeAttribute('aria-pressed');
          });
        }
        this.select(0);
        this.playbackSurface.tabIndex = 0;
        this.playbackSurface.setAttribute('role', 'button');
        this.playbackSurface.setAttribute('aria-label', this.dataset.controlLabel);
        on(this.playbackSurface, 'click', () => this.togglePlayback());
        on(this.playbackSurface, 'keydown', event => {
          if (event.key !== ' ' && event.key !== 'Enter') return;
          if (this.video?.controls) return;
          event.preventDefault();
          this.togglePlayback();
        });
        on(this.motion, 'change', () => {
          if (this.motion.matches) { this.wantsPlayback = false; this.syncPlayback(); }
        });
        on(document, 'visibilitychange', () => this.syncPlayback());
        on(this, 'shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, {threshold:0.15});
        this.observer.observe(this.querySelector('.dpe-joint__visuals'));
        this.showPlayback(false);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.video?.pause();
        this.events = null;
      }
      select(index) {
        this.activeIndex = index;
        this.tabs.forEach((tab,i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
          if (this.visuals[i]) this.visuals[i].hidden = i !== index;
          if (this.captions[i]) this.captions[i].hidden = i !== index;
        });
        this.seekChapter();
        this.syncPlayback();
      }
      chapterRange() {
        const duration = this.video?.duration || 0;
        const tab = this.tabs[this.activeIndex];
        const requestedStart = Math.max(0, Number(tab.dataset.start) || 0);
        const start = requestedStart < duration ? requestedStart : 0;
        const requestedEnd = Number(tab.dataset.end) || duration;
        const end = requestedEnd > start ? Math.min(duration, requestedEnd) : duration;
        return {start, end};
      }
      seekChapter() {
        if (this.progress) this.progress.style.width = '0%';
        if (!this.video || !Number.isFinite(this.video.duration)) return;
        this.video.currentTime = this.chapterRange().start;
      }
      updateTimeline() {
        const {start, end} = this.chapterRange();
        if (!end || end <= start) return;
        if (this.video.currentTime >= end - 0.05 && this.wantsPlayback) this.video.currentTime = start;
        const progress = Math.max(0, Math.min(100, (this.video.currentTime - start) / (end - start) * 100));
        if (this.progress) this.progress.style.width = `${progress}%`;
      }
      syncPlayback() {
        const playing = this.wantsPlayback && this.inView && !document.hidden;
        if (!this.video) { this.showPlayback(playing); return; }
        if (playing) {
          if (this.video.readyState === 0) this.video.preload = 'metadata';
          this.video.play().catch(() => {
            if (!this.inView || document.hidden) return;
            this.wantsPlayback = false;
            this.showPlayback(false);
          });
        } else { this.video.pause(); this.showPlayback(false); }
      }
      togglePlayback() {
        if (this.video?.controls) return;
        this.wantsPlayback = !this.wantsPlayback;
        this.syncPlayback();
      }
      showPlayback(playing) {
        this.dataset.playing = String(playing);
        if (!this.video?.controls) this.playbackSurface.setAttribute('aria-pressed', String(playing));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpe-product-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpe-product-gallery')) {
    customElements.define('dpe-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.photos = [...this.querySelectorAll('[data-gallery-photo]')];
        this.controls = this.querySelector('[data-gallery-controls]');
        this.buttons = this.controls ? [...this.controls.querySelectorAll('button')] : [];
        if (!this.photos.length) return;
        this.select(this.photos[0].id);
        if (this.controls) {
          this.controls.hidden = false;
          this.controls.addEventListener('click', (event) => {
            const button = event.target.closest('button');
            if (button && this.controls.contains(button)) this.select(button.getAttribute('aria-controls'));
          });
          this.controls.addEventListener('keydown', (event) => {
            const current = this.buttons.indexOf(event.target);
            if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = current;
            if (event.key === 'ArrowRight') next = (current + 1) % this.buttons.length;
            if (event.key === 'ArrowLeft') next = (current + this.buttons.length - 1) % this.buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.buttons.length - 1;
            this.select(this.buttons[next].getAttribute('aria-controls'));
            this.buttons[next].focus({ preventScroll: true });
          });
        }
        this.addEventListener('shopify:block:select', (event) => {
          const photo = event.target.closest('[data-gallery-photo]');
          if (photo) this.select(photo.id);
        });
      }
      select(id) {
        this.photos.forEach((photo) => { photo.hidden = photo.id !== id; });
        this.buttons.forEach((button) => { button.setAttribute('aria-pressed', String(button.getAttribute('aria-controls') === id)); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
